import callApiAxiosClient from '../../axios/axios_client';

type AddTechnicalIncidentArgs = {
  cameraId: number;
  eventTypeId: number;
  image: File;
  message?: string;
};

async function addTechnicalIncident({ cameraId, eventTypeId, image, message }: AddTechnicalIncidentArgs): Promise<void> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;

  const formData = new FormData();
  formData.append('CameraId', cameraId.toString());
  formData.append('EventTypeId', eventTypeId.toString());
  // The backend contract appears to vary between EventTypeId and EventyTypeId.
  formData.append('EventyTypeId', eventTypeId.toString());
  formData.append('Image', image);
  message && formData.append('Message', message);

  return callApiAxiosClient<void>({
    method: 'post',
    url: 'technicalincidents',
    headers: {
      Authorization: authorization,
    },
    data: formData,
  });
}

export default addTechnicalIncident;
